module.exports = __webpack_public_path__ + "static/media/parachuting-normal-yeti.109a9954.png";